"use client";

export function ThreadSidebarSkeleton() {
  return (
    <aside className="flex w-full pt-0 lg:w-[340px] h-[500px] lg:h-full lg:items-center animate-pulse">
      <div className="w-full flex flex-col gap-5">
        {/* Title */}
        <div className="h-7 w-2/3 bg-background-elevated-2 rounded-md" />

        {/* Prompt Section */}
        <div className="flex flex-col gap-2">
          <div className="h-4 w-16 bg-background-elevated-2 rounded-sm" />
          <div className="h-40 w-full bg-background-elevated-2 rounded-xl" />
        </div>

        {/* Share Section */}
        <div className="flex flex-col gap-2">
          <div className="h-4 w-12 bg-background-elevated-2 rounded-sm" />
          <div className="flex gap-3">
            <div className="flex-1 h-9 bg-background-elevated-2 rounded-full" />
            <div className="flex-1 h-9 bg-background-elevated-2 rounded-full" />
            <div className="flex-1 h-9 bg-background-elevated-2 rounded-full" />
            <div className="flex-3 h-9 bg-background-elevated-2 rounded-full min-w-[130px]" />
          </div>
        </div>

        {/* Action Buttons */}
        <div className="flex gap-4 mt-5">
          <div className="flex-1 h-10 bg-background-elevated-2 rounded-full" />
          <div className="flex-1 h-10 bg-background-elevated-2 rounded-full" />
        </div>
      </div>
    </aside>
  );
}
